import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "../assets/scss/app.scss";
import Home from "../views/Home/Home";
import DoceCasos from "../views/DoceCasos/DoceCasos";
import FichaDoceCasos from "../views/DoceCasos/FichaDoceCasos";
import FichaDoceCasosMaestro from "../views/DoceCasos/Ficha";
import OtrosFuncionarios from "../views/OtrosFuncionarios/OtrosFuncionarios";
import FichaOtrosFuncionarios from "../views/OtrosFuncionarios/Ficha";
import Buscador from "../views/Buscador/Buscador";
import FichaMaestro from "../views/FichaMaestro/FichaMaestro";
import LineaTiempo from "../views/LineaTiempo/LineaTiempo";
import RespondeHistoriadora from "../views/RespondeHistoriadora/RespondeHistoriadora";
import Glosario from "../views/Glosario/Glosario";
import Creditos from "../views/Creditos/Creditos";
import Actividades from "../views/Actividades/Actividades";
import TrabajosAlumnado from "../views/TrabajosAlumnado/TrabajosAlumnado";
import Mapa from "../views/Mapa/Mapa";


const App = () => {


  return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path={'/buscador/'} element={<Buscador  section_id="1"/>} />
        <Route path={'/mapa/'} element={<Mapa section_id="2"/>} />
        <Route path={'/linea-de-tiempo/'} element={<LineaTiempo section_id="3"/>} />
        <Route path={'/responde-la-historiadora/'} element={<RespondeHistoriadora section_id="4"/>} />
        <Route path={'/glosario/'} element={<Glosario section_id="5"/>} />
        <Route path={'/doce-casos/'} element={<DoceCasos section_id="6"/> } />
        <Route path={'/otros-funcionarios-represaliados/'} element={<OtrosFuncionarios section_id="59"/> } />
        <Route path={'/actividades/'} element={<Actividades section_id="7"/> } />
        <Route path={'/trabajos-del-alumnado/'} element={<TrabajosAlumnado section_id="8"/> } />
        <Route path={'/creditos/'} element={<Creditos section_id="138"/> } />

        <Route path={"/doce-casos/ficha/:section_id"} element={<FichaDoceCasos />} />
        <Route path={"/doce-casos/ficha-maestro/:section_id"} element={<FichaDoceCasosMaestro />} />
        <Route path={"/buscador/ficha/:section_id"} element={<FichaMaestro />} />
        <Route path={"/mapa/ficha/:section_id"} element={ <FichaMaestro mapa="true" />} />
        <Route path={"/otros-funcionarios-represaliados/ficha/:section_id"} element={<FichaOtrosFuncionarios />} />
      </Routes>
  );
};

export default App;
